import { render } from "./ContactSection.vue?vue&type=template&id=1da9c7e6&bindings={\"showContactForm\":\"data\",\"isDarkBg\":\"options\",\"toggleForm\":\"options\"}"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"
script.render = render

export default script